import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const importAPI = createApi({
  reducerPath: "importAPI",
  baseQuery: fetchBaseQuery(),
  endpoints: (builder) => ({
    //* *********************************************************** */
    //* ANALYZE IMPORT - uploads pg_dump file for analysis */
    analyzeImport: builder.mutation({
      query: (body: any) => {
        const formData = new FormData();
        formData.append("file", body.body.file);
        formData.append("parent_org_id", body.body.parent_org_id);
        if (body.body.database) {
          formData.append("database", body.body.database);
        }
        if (body.body.uuid_policy) {
          formData.append("uuid_policy", JSON.stringify(body.body.uuid_policy));
        }
        return {
          url: `${process.env.REACT_APP_LIFT_NET_CLOUD_API_ONLINE}/import/organization/analyze`,
          method: "POST",
          body: formData,
          headers: {
            authorization: body.token,
          },
        };
      },
    }),
    //* *********************************************************** */
    //* EXECUTE IMPORT - applies resolutions and imports data */
    executeImport: builder.mutation({
      query: (body: any) => ({
        url: `${process.env.REACT_APP_LIFT_NET_CLOUD_API_ONLINE}/import/organization/execute`,
        method: "POST",
        body: body.body,
        headers: {
          authorization: body.token,
          "Content-Type": "application/json",
        },
      }),
    }),
    //* *********************************************************** */
  }),
});

export const { useAnalyzeImportMutation, useExecuteImportMutation } = importAPI;
